import React, { useState } from 'react';

import Switch from '../../../Switch';
import type { PersonData } from '../../types';

interface PersonSwitchProps {
  person: PersonData;
  onAttendedToggle: (person: PersonData, status: boolean) => void;
  isAttendedToggleLoading: boolean;
  disabled?: boolean;
}

const PersonSwitch: React.FC<PersonSwitchProps> = ({
  person,
  onAttendedToggle,
  isAttendedToggleLoading = false,
  disabled,
}) => {
  const { attended } = person;
  const [attend, setAttend] = useState(attended);
  const handleAttendedSwitch = (status: boolean) => {
    setAttend(status);
    onAttendedToggle(person, status);
  };

  return (
    <div>
      <Switch
        id="qa_priceToggle"
        checkedColor={'default'}
        checked={attend}
        onChange={() => handleAttendedSwitch(!attend)}
        disabled={isAttendedToggleLoading || disabled}
      />
    </div>
  );
};

export default PersonSwitch;
